import React, { createContext, useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";

// Create the MenuContext with a default value of 'show'
const MenuContext = createContext({
  menuState: "show", 
  toggleMenu: () => {},
});

// Custom hook to use MenuContext
export const useMenu = () => useContext(MenuContext);

// Provider component to wrap around the app
export const MenuProvider = ({ children }) => {
  
  const cookieMenu = Cookies.get("menu") || "show";

  // Manage the menu state
  const [menuState, setMenuState] = useState(cookieMenu);

  // Update the cookie when the state changes
  useEffect(() => {
    Cookies.set("menu", menuState, { expires: 2 }); // Cookie expires in 2 days
  }, [menuState]);

  // Toggle the menu state
  const toggleMenu = () => {
    setMenuState((prevState) => (prevState === "show" ? "hide" : "show"));
  };

  return (
    <MenuContext.Provider value={{ menuState, toggleMenu }}>
      {children}
    </MenuContext.Provider>
  );
};
